import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=b1f50e14&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=ts"
export * from "./Verification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f50e14",
  null
  
)

export default component.exports